import { render, staticRenderFns } from "./RpcsTag.vue?vue&type=template&id=668aa860"
import script from "./RpcsTag.vue?vue&type=script&lang=js"
export * from "./RpcsTag.vue?vue&type=script&lang=js"
import style0 from "./RpcsTag.vue?vue&type=style&index=0&id=668aa860&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports